import { Artist } from "@prisma/client";

import { ArtistImage } from "../ArtistImage/ArtistImage";
import { cn } from "../utils";

interface Props {
  artist: Artist;
  isSelected: boolean;
  onClick: (artistId: string) => void;
}
export function ArtistFilterItem({ artist, isSelected, onClick }: Props) {
  function handleClick() {
    onClick(artist.id);
  }

  return (
    <button onClick={handleClick}>
      <ArtistImage
        key={artist.id}
        alt={artist.name}
        url={artist.imageUrl}
        className={cn(
          "transition-none w-max h-max",
          isSelected ? "border-primary border" : "opacity-60",
        )}
      />
    </button>
  );
}
